import React, { Component, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import store from "../../../redux/store";

export class Timer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillReceiveProps = (nextProps) => {};

  shouldComponentUpdate = (nextProps) => {
    return false;
  };

  render() {
    const { data, ...rest } = this.props;
    return <_Timer {...this.props} />;
  }
}

export const _Timer = (props) => {
  // 02M : 10S
  const [timer, setTimer] = useState("");

  const start_time1 = useSelector((state) => {
    return state.ticker.call_start_time;
  });

  const show = (isMountedRef) => {
    return setTimeout(() => {
      const start_time = store.getState().ticker.call_start_time;

      if (start_time && isMountedRef.current) {
        let duration = moment.duration(moment().diff(start_time));
        let durationInMinsAndSecs = moment
          .utc(duration.as("milliseconds"))
          .format("mm:ss");

        const splits = durationInMinsAndSecs.split(":");
        let mm = "";
        let ss = "";

        if (props.disableSymbols) {
          mm = splits[0] || "00";
          ss = splits[1] || "00";
        } else {
          mm = `${splits[0]}M` || "00M";
          ss = `${splits[1]}S` || "00S";
        }

        const timeFmt = `${mm}  :  ${ss}`;
        setTimer(timeFmt);
      }

      if (isMountedRef.current) {
        return show(isMountedRef);
      }
    }, 500);
  };

  useEffect(() => {
    const isMountedRef = { current: true }; // Track mount state
    const timer = show(isMountedRef);

    return () => {
      isMountedRef.current = false; // Set to false when unmounted
      if (timer) clearTimeout(timer); // Clear timer
    };
  }, []);

  return <span>{timer}</span>;
};
